import React from "react";
import getItemOptions from "../../../../../lib/getItemOptions";

const ItemsDetail = ({ items }) => {
  const basketData = { items };
  return (
    <div className="restaurant-detail">
      <div className="white-bg detail-item mt-10px padding-box">
        <ul>
          {items.map(item => (
            <li className="title" key={item.id}>
              <div className="d-flex justify-content-between">
                <div>
                  <div className="d-flex item-div">
                    <span>
                      <p>
                        {item.quantity}x {item.name}
                      </p>
                    </span>
                    {(item.types &&
                      item.types.length &&
                      item.types.map(type => (
                        <React.Fragment key={type.id}>
                          <span
                            className={`badge ${(type.id === 7 && "blue") ||
                              ""}`}
                          >
                            {type.name}
                          </span>
                        </React.Fragment>
                      ))) || <noscript />}
                  </div>

                  <p className="light">{getItemOptions(basketData, item.id)}</p>
                </div>

                <div className="pricing pricing-orders">
                  <p>£{parseFloat(item.totalAmount).toFixed(2)}</p>
                </div>
                {/* .pricing */}
              </div>
              {/* .d-flex */}
            </li>
          ))}
        </ul>
        {/* .items */}
      </div>
      {/* .detail-item */}
    </div>
  );
};
export default ItemsDetail;
